import React, { createContext, useState } from "react";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
  CognitoRefreshToken,
} from "amazon-cognito-identity-js";
import Pool from "../UserPool";
import { getUserProfileTokenName, STORAGE_KEY } from "./shared/helpers/helper";

const AccountContext = createContext();

const Account = (props) => {
  // Gets the session of current logged in User
  const getSession = async () =>
    await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession(async (err, session) => {
          if (err) {
            reject();
          } else {
            const attributes = await new Promise((resolve, reject) => {
              user.getUserAttributes((err, attributes) => {
                if (err) {
                  reject(err);
                } else {
                  const results = {};
                  results["user_name"] = user.getUsername();
                  for (let attribute of attributes) {
                    const { Name, Value } = attribute;
                    results[Name] = Value;
                  }
                  localStorage.setItem(
                    getUserProfileTokenName(),
                    JSON.stringify(results),
                  );
                  console.log(results);
                  resolve(results);
                }
              });
            });

            resolve({
              user,
              ...session,
              ...attributes,
            });
          }
        });
      } else {
        reject();
      }
    });

  /**
   *
   * Login function to auth - First login check
   * @param {*} Username
   * @param {*} Password
   * @param {*} newPassword
   * @returns
   */
  const authenticate = async (Username, Password, newPassword) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          console.error("onFailure:", err);
          reject(err);
        },

        newPasswordRequired: (data, requiredAttribute) => {
          data["isFirstLogin"] = true;

          if (newPassword) {
            delete data.email_verified;

            delete data.isFirstLogin;
            delete data.passwordChanged;
            data.address = "empty";
            data.given_name = "empty";
            data.family_name = "empty";

            // Wait for Cognito to confirm; resolving early lets Login re-auth with the new password before it exists.
            user.completeNewPasswordChallenge(newPassword, data, {
              onSuccess: () => resolve({ ...data, passwordChanged: true }),
              onFailure: (err) => {
                console.error("completeNewPasswordChallenge:", err);
                reject(err);
              },
            });
          } else {
            resolve(data);
          }
        },
      });
    });
  const changePassword = (password, newPassword) => {
    return new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      user.getSession((err, session) => {
        if (err) reject(err);
        else {
          user.changePassword(password, newPassword, function (err, result) {
            if (err) reject(err);
            else resolve(result);
          });
        }
      });
    });
  };
  const refreshSession = () => {
    console.log("Refresh session");
    var userName = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        ".LastAuthUser",
    );

    var refreshToken = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_CLIENT_ID +
        "." +
        userName +
        ".refreshToken",
    );
    const user = Pool.getCurrentUser();
    var token = new CognitoRefreshToken({ RefreshToken: refreshToken });
    user.refreshSession(token, (err, session) => {});
  };

  const getAttributes = () => {
    const user = Pool.getCurrentUser();
    user.getUserAttributes(function (err, result) {
      if (err) {
        alert(err.message || JSON.stringify(err));
        return;
      }
    });
  };
  const logout = () => {
    const user = Pool.getCurrentUser();
    if (user) {
      localStorage.removeItem(STORAGE_KEY);
      var state = localStorage.getItem("dirty");
      window.onbeforeunload = null;
      if (state === "true") {
        if (
          window.confirm(
            "You have unsaved changes, are you sure you want to continue?",
          )
        ) {
          window.location.reload();
          user.signOut();
        } else {
        }
      } else {
        window.location.reload();
        user.signOut();
      }
    }
  };

  return (
    <AccountContext.Provider
      value={{
        authenticate,
        getSession,
        logout,
        changePassword,
        refreshSession,
        getAttributes,
      }}
    >
      {props.children}
    </AccountContext.Provider>
  );
};

export { Account, AccountContext };
